import useFlowTranslate from 'FlowBuilder/hooks/useFlowTranslate'

export default function QuestionNumber({ currentPage, totalPages }) {
  const safeTotalPages = Math.max(currentPage, totalPages);
  const { fallback: { questionNumberText } } = useFlowTranslate()

  const text = questionNumberText
    .replace(/{{\s*current\s*}}/g, currentPage.toString())
    .replace(/{{\s*total\s*}}/g, safeTotalPages.toString())

  return (
    <div className="question-number-container">
      <p className="question-number-text">
        {text}
      </p>
    </div>
  );
}
